import { useLocation } from "react-router-dom";
import { AppLayout } from "../../layout/AppLayout";
import { ListaClientes } from "../../view/Clientes/ListaClientes";
import { usePathAndData } from "../../../hook/usePathAndData";
import { PerfilUsuario } from "../../view/PefilCliente/perfil/PerfilUsuario";



export const PageClientes = () => {
    const { path, dataValue } = usePathAndData(); // Usa el hook
    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "clientes" && path[2] === "lista" && <ListaClientes />}
                                {path[1] === "clientes" && path[2] === "perfil" && <PerfilUsuario />}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
